import { render, staticRenderFns } from "./ModalTriggerBot.vue?vue&type=template&id=70198bd6"
import script from "./ModalTriggerBot.vue?vue&type=script&lang=js"
export * from "./ModalTriggerBot.vue?vue&type=script&lang=js"
import style0 from "./ModalTriggerBot.vue?vue&type=style&index=0&id=70198bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports